import { render, staticRenderFns } from "./connection-teamtailor-api.vue?vue&type=template&id=c2a36dcc&scoped=true&"
import script from "./connection-teamtailor-api.ts?vue&type=script&lang=ts&"
export * from "./connection-teamtailor-api.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a36dcc",
  null
  
)

export default component.exports